import { render, staticRenderFns } from "./RichEditorComponent.vue?vue&type=template&id=f62a293c&"
import script from "./RichEditorComponent.vue?vue&type=script&lang=js&"
export * from "./RichEditorComponent.vue?vue&type=script&lang=js&"
import style0 from "./RichEditorComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports